import { Route } from "react-router-dom";
import { withRedirect } from "./hocs";

export default withRedirect(Route);



// WEBPACK FOOTER //
// ./src/app/auth/AuthRoute.js